import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { CalendarClock, Save, Loader2, ClipboardCheck } from "lucide-react";
import { toast } from "sonner";

const ESITI = [
  { value: "", label: "— Seleziona esito —" },
  { value: "ok", label: "OK" },
  { value: "ko_tecnico", label: "KO Tecnico" },
  { value: "ko_commerciale", label: "KO Commerciale" },
];

const esitoStyle = (v) => {
  if (v === "ok") return { color: "#047857", background: "rgba(16,185,129,0.12)", border: "1px solid rgba(16,185,129,0.35)" };
  if (v === "ko_tecnico" || v === "ko_commerciale") return { color: "#B30000", background: "rgba(220,38,38,0.10)", border: "1px solid rgba(220,38,38,0.35)" };
  return { borderColor: "var(--border)", background: "#fff" };
};

export default function SopralluogoDateBlock({ cid, initialDate, initialEsito, readOnly = false, onSaved }) {
  const [date, setDate] = useState((initialDate || "").slice(0, 10));
  const [esito, setEsito] = useState(initialEsito || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => { setDate((initialDate || "").slice(0, 10)); }, [initialDate]);
  useEffect(() => { setEsito(initialEsito || ""); }, [initialEsito]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/clienti/${cid}/sopralluogo/data`, { data_sopralluogo: date, esito_sopralluogo: esito });
      toast.success("Sopralluogo salvato");
      onSaved?.();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="card-shell p-4 flex flex-wrap items-end gap-3" data-testid="sopralluogo-data-block">
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider flex items-center gap-1" style={{ color: "var(--text-muted)" }}>
          <CalendarClock className="w-3.5 h-3.5" /> Data sopralluogo effettuato
        </label>
        <input type="date" value={date} disabled={readOnly} onChange={(e) => setDate(e.target.value)}
          className="mt-1 px-3 py-2 text-sm rounded-md border outline-none disabled:opacity-60"
          style={{ borderColor: "var(--border)", background: "#fff" }}
          data-testid="sopralluogo-data-input" />
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider flex items-center gap-1" style={{ color: "var(--text-muted)" }}>
          <ClipboardCheck className="w-3.5 h-3.5" /> Esito Sopralluogo
        </label>
        <select value={esito} disabled={readOnly} onChange={(e) => setEsito(e.target.value)}
          className="mt-1 px-3 py-2 text-sm rounded-md border outline-none disabled:opacity-60 font-semibold"
          style={esitoStyle(esito)}
          data-testid="sopralluogo-esito-select">
          {ESITI.map((o) => <option key={o.value} value={o.value} style={{ color: "#111", background: "#fff" }}>{o.label}</option>)}
        </select>
      </div>
      {!readOnly && (
        <button onClick={save} disabled={saving} className="btn-primary text-sm" data-testid="sopralluogo-data-save">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salva
        </button>
      )}
      <span className="text-xs flex-1 min-w-[200px]" style={{ color: "var(--text-muted)" }}>
        Data usata per contabilizzare il sopralluogo nel mese corretto in Analytics.
      </span>
    </div>
  );
}
